// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2ocMd","head":"Table_head__1tE0E","col":"Table_col__34i0T"};